import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { HERO_PORTRAIT } from "@/data/products";
import { optimizedImg, srcSetFor } from "@/lib/img";

export default function StylePurpose() {
  return (
    <section
      data-testid="style-purpose-section"
      className="relative bg-[var(--st-bg)] py-16 md:py-24 border-b-2 border-[#111]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="relative grid grid-cols-12 gap-3 items-center"
        >
          {/* Backing mustard panel — full content height so headline never
              spills above it on small screens. */}
          <div className="absolute inset-0 bg-[var(--st-mustard)] border-2 border-[#111] shadow-brutal -z-0" />

          <div className="relative z-10 col-span-12 lg:col-span-8 px-4 pt-8 pb-2 lg:py-10">
            <h2 className="font-display uppercase leading-[0.9] tracking-tight text-[var(--st-maroon)] text-[14vw] sm:text-[12vw] md:text-[9vw] lg:text-[6.4vw]">
              MERCH WITH
              <br />
              <span className="text-white">A PURPOSE</span>
            </h2>
          </div>

          <div className="relative z-10 col-span-12 lg:col-span-3 px-4 pb-8 lg:py-10 lg:pl-0 lg:pr-4">
            <p className="font-body text-base text-[var(--st-fg)] leading-relaxed">
              Every piece is built like the show — sharp, soulful, and made to last.
              Premium fabrics, ethical production, designed by the team that lives in
              the classroom of the culture.
            </p>
            <a
              href="#shop"
              data-testid="purpose-shop-cta"
              className="mt-5 inline-flex items-center gap-2 font-heading uppercase tracking-[0.18em] text-sm bg-[var(--st-fg)] text-[var(--st-gold)] px-4 py-2 border-2 border-[#111] hover:bg-[var(--st-maroon)] hover:text-white transition-colors"
            >
              Shop the Drop <ArrowUpRight size={14} />
            </a>
          </div>

          <div className="relative z-10 col-span-1 hidden lg:block lg:py-6 lg:pr-4">
            <div className="aspect-[3/4] border-2 border-[#111] overflow-hidden bg-[var(--st-cream)] shadow-brutal-sm">
              <img
                src={optimizedImg(HERO_PORTRAIT, 480)}
                srcSet={srcSetFor(HERO_PORTRAIT, [240, 360, 480, 600])}
                sizes="(max-width: 1024px) 0px, 12vw"
                alt="CB3 in look"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
